// tslint:disable:max-line-length
import * as React from 'react';

export const Favorites = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0)">
      <path
        d="M1 5.90814C1 11.0647 8 15 8 15C8 15 15 11.0647 15 5.90814C15 3.74973 13.2405 2 11.0701 2C9.82783 2 8.72015 2.57327 8 3.46831C7.27985 2.57327 6.17217 2 4.92985 2C2.75946 2 1 3.74973 1 5.90814Z"
        stroke="#737A8E"
        strokeWidth="2"
      />
    </g>
    <defs>
      <clipPath id="clip0">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
